<template>
  <div class="consult-dialog">
    <div
      class="shop-service-box"
      :style="consultDialog ? 'display: flex' : 'display: none'"
    >
      <div class="shop-service-content">
        <div class="shop-top">
          <i
            class="el-icon-close closeShop"
            @click="consultDialogClose(false)"
          ></i>
        </div>
        <div class="commit-service">
          <img
            class="kefu-image"
            :src="require('@/assets/images/kefu_image.png')"
            alt=""
          />
          <div class="hint">您可以拨打电话或者在线咨询</div>
          <div class="call-online">
            <div
              class="online"
              id="targetBtn"
              data-count="官网-立即咨询-在线客服"
            >
              <div class="slider-item online-consult">
                <i class="iconfont iconkefu_icon"></i>
                <span class="call-content">在线客服</span>
              </div>
            </div>
            <div class="call" data-count="官网-立即咨询-电话咨询">
              <a href="tel:4001026665">
                <i class="iconfont iconphone_icon"></i>
                <span class="call-content"> 电话咨询 </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-service-box">
      <div
        id="consultClick"
        class="shopService serviceShop"
        @click="consultDialogClose(true)"
      >
        开店咨询
      </div>
      <a href="/" class="foot-free-btn" target="_blank" rel="nofollow"
        >免费试用7天</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      consultDialog: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.consultDialog = true;
    }, 20000);
  },
  methods: {
    consultDialogClose(bool) {
      this.consultDialog = bool;
    }
  }
};
</script>

<style lang="scss">
.consult-dialog {
  .shop-service-box {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .shop-service-content {
    width: 5.6rem;
    height: 4.54rem;
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    padding: 0.64rem 0.48rem;
    text-align: center;
  }

  .shop-service-content .kefu-image {
    width: 1.68rem;
    height: 1.68rem;
  }

  .shop-service-content .shop-top {
    position: absolute;
    padding: 0.2rem;
    right: 0.04rem;
    top: 0.04rem;
  }

  .shop-service-content .shop-top img {
    width: 0.24rem;
    height: 0.24rem;
  }

  .commit-service .call-online {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 0.28rem;
    margin-top: 0.48rem;
  }

  .commit-service .call-online .call,
  .commit-service .call-online .call a {
    color: #fff;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 0.44rem;
    width: 2.16rem;
    height: 0.64rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .commit-service .call-online .call {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #1472ff;
  }

  .commit-service .call-online .call a {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    line-height: 0.64rem;
  }

  .commit-service .call-online .online {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 0.44rem;
    width: 2.16rem;
    height: 0.64rem;
    color: #1472ff;
    background: #fff;
    border: 1px solid #1472ff;
  }

  .commit-service .call-online .online .online-consult {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
  }

  .commit-service .call-online .call-content {
    margin-left: 3px;
  }
  .closeShop {
    font-size: 0.32rem;
    color: #a6a6a6;
  }

  .mobile-service-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 99;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    line-height: 1rem;
    background: #fff;
    font-size: 0.32rem;
    text-align: center;
    border-top: 1px solid #e2e2e2;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .mobile-service-box .shopService {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 50%;
    background: #fff;
    color: #1472ff;
    border-bottom: 0.02rem solid #e2e2e2;
  }

  .mobile-service-box .shopService img {
    margin-right: 0.06rem;
    width: 0.36rem;
  }

  .mobile-service-box .foot-free-btn {
    display: inline-block;
    width: 50%;
    background-color: #1472ff;
    color: #fff;
    border-bottom: 0.02rem solid #e2e2e2;
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .mobile-service-box {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
